import SelectWidget from '@/components/common/Form/widgets/SelectWidget';
import TextWidget from '@/components/common/Form/widgets/TextWidget';

export default {
  EmailWidget: TextWidget,
  TextWidget,
  SelectWidget,
};
